import React from "react";
import { Container, Row } from "react-bootstrap";
import Post from "./Post";

function Projects() {
  return (
      <Container fluid className="project-section" style={{ marginTop: '10px' }} >
      <Container>
        <Row style={{ justifyContent: "center", paddingTop: "32px" }}>
            <h1 className="project-heading">
              Our Recent <strong className="purple">Works </strong>
            </h1>
                  <p style={{ color: "#3e5172" }}>
              Here are a few projects We've worked on recently.
            </p>
        </Row>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            <Post />
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
